import CheckBoxes from 'Site/component/CheckBoxes.vue';
import coverImageMixin from 'Site/js/mixin/cover.image';
import Form from 'Site/js/util/form';
import Geocomplete from 'Location/component/Geocomplete.vue';
import SiteInput from 'Site/component/SiteInput.vue';
import SiteTextArea from 'Site/component/SiteTextArea.vue';
import SiteSelect from 'Site/component/SiteSelect.vue';
import store from 'Site/js/store';
import Vue from 'vue';
import { mapState } from 'vuex';
import Wysiwyg from 'Site/component/Wysiwyg.vue';

export default function () {
    let coverImage = '';
    if (store.state.config.data.currentCover) {
        coverImage = store.state.config.data.currentCover.media.smallcover ?
            store.state.config.data.currentCover.media.smallcover.url : store.state.config.data.currentCover.media.medium.url;
    } else {
        coverImage = store.state.config.data.coverUrl.replace('REPLACE', `${store.state.config.data.currentTheme || 'bubbles'}/small.jpg`);
    }

    const { data } = store.state.config;

    new Vue({ /* eslint no-new:0 */
        el: '#page-body',
        name: 'eventCreate',
        store,
        components: {
            CheckBoxes,
            Geocomplete,
            SiteInput,
            SiteSelect,
            SiteTextArea,
            Wysiwyg
        },
        computed: mapState(['config', 't']),
        data: {
            coverImage,
            coverImageName: store.state.config.data.currentTheme || 'bubbles',
            coverImageMedia: store.state.config.data.currentCover,
            form: new Form({
                capacity: data.capacity,
                title: data.title,
                isCommercial: data.isCommercial,
                description: data.description,
                type: data.type,
            }, {
                title: [{ type: 'required' }, { type: 'max', value: 500 }],
                description: ['required'],
                type: ['required'],
                capacity: [{ type: 'required' }, { type: 'max', value: 200 }]
            }),
            latitude: '',
            longitude: '',
        },
        methods: {
            changeCoverImage(newCoverImage) {
                this.showCoverImageModal = false;
                this.coverImage = newCoverImage.url;
                if (!newCoverImage.site) {
                    this.coverImageName = null;
                    this.coverImageMedia = newCoverImage;
                } else {
                    this.coverImageName = newCoverImage.name;
                    this.coverImageMedia = null;
                }
            },
            setLatLng({ result }) {
                this.latitude = result.geometry.location.lat();
                this.longitude = result.geometry.location.lng();
            },
            submit(e) {
                if (!this.form.validate()) {
                    e.preventDefault();
                    document.querySelector('html').scrollTop = 0;
                }
            },
            validate(e) {
                let field = null;
                if (typeof e === 'string') {
                    field = e;
                } else {
                    field = e.srcElement.name;
                }
                this.$nextTick(() => {
                    this.form.errors.clear(field);
                    this.form.validate(field);
                });
            },
        },
        mixins: [coverImageMixin],
        mounted() {
            this.latitude = this.config.data.latitude || '';
            this.longitude = this.config.data.longitude || '';
        }
    });
}
